import io from 'socket.io-client';
import { getApiUrl } from '../helpers/get-api-url';

interface IConfig {
    Authorization?: string | null;
    operatorId?: string | null;
    gameMode?: string;
}

export class WebsocketService {
    public ws: typeof io.Socket | null;

    constructor() {
        this.ws = null;
    }

    init(operatorId?: string | null, token?: string, gameMode?: string): void {
        const config: IConfig = {
            operatorId: operatorId,
            Authorization: token || null,
        };
        if (gameMode) config.gameMode = gameMode;

        const connectionURL = getApiUrl(window.env.REACT_APP_WS_URL) || '';
        this.ws = io.connect(connectionURL, {
            path: `/io`,
            transports: ['websocket'],
            query: config,
        });
    }
}